import { render, staticRenderFns } from "./CandleInfo.vue?vue&type=template&id=58165f36&scoped=true&lang=pug&"
import script from "./CandleInfo.vue?vue&type=script&lang=ts&"
export * from "./CandleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CandleInfo.vue?vue&type=style&index=0&id=58165f36&scoped=true&lang=scss&"
import style1 from "./CandleInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58165f36",
  null
  
)

export default component.exports